import React, { useState } from "react";
import { TextInput } from "../components/form/inputs";
import ToggleBtn from "../components/button/ToggleBtn";
import DecorativeSquares from "../components/ui/DecorativeSquares"; 
import { useNavigate } from "react-router-dom";
import InputBase from "../components/form/inputs/InputBase";
import PrimaryBtn from "../components/button/PrimaryBtn";
import { FaArrowLeft } from "react-icons/fa";

const Addnewaddress = () => {
  const [isDeliveryEnabled, setIsDeliveryEnabled] = useState(false);
  const navigate = useNavigate();

  const openGoogleMap = () => {
    // You can replace this with navigate("/map") later
    window.open("https://www.google.com/maps", "_blank");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const currencySymbol = localStorage.getItem("currency");
  return (
    <section className="relative min-h-screen  bg-slate-50 space-y-10">
      <DecorativeSquares />

      {/* Header */}
      <div className="flex items-center h-14 mt-5 bg-white px-8 shadow-sm">
        <button
          onClick={handleGoBack}
          className="flex items-center p-2 rounded-full hover:bg-gray-100"
        >
          <FaArrowLeft size={20} /> 
        </button>

        <h1 className="mx-auto text-2xl font-semibold text-gray-900">
          Add New Address
        </h1>
      </div>
      <div className="px-4 mt-8">
        <div className="mx-auto space-y-4 w-full max-w-3xl bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
          {/* ================= Address Form ================= */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <TextInput
              label="Address line 1"
              placeholder="Enter Address Line 1"
              name="addressLineOne"
            />
            <InputBase
              type="textarea"
              label="Address line 2"
              placeholder="Apartment, House No, Landmark"
              name="addressline2"
              rows={2}
            />
            <TextInput
              label="Country Name"
              placeholder="Enter Country Name"
              name="country"
            />
            <TextInput label="City" placeholder="Enter City" name="city" />
            <TextInput
              label="Province / State"
              placeholder="Enter Province"
              name="province"
            />
            <TextInput
              label="Pin Code"
              placeholder="Enter Pin Code"
              name="pincode"
            />
          </div>
          {/* ================= Google Map ================= */}
          <div className="space-y-2">
            <p className="text-[#191919] font-medium">Choose location</p>

            <div
              onClick={() =>
                window.open("https://www.google.com/maps", "_blank")
              }
              className="relative w-full h-64 rounded-xl overflow-hidden border border-[#E5E5E5] cursor-pointer group"
            >
              {/* MAP */}
              <iframe
                title="pickup-location"
                src="https://www.google.com/maps?q=India&z=5&output=embed"
                className="w-full h-full pointer-events-none"
                loading="lazy"
              />

              {/* OVERLAY */}
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition flex items-center justify-center">
                <div className="bg-white px-4 py-2 rounded-lg shadow text-sm font-medium text-[#191919]">
                  Click to select location on map
                </div>
              </div>
            </div>
          </div>
          <div>
            <PrimaryBtn btnName="Add" clickEvent={() => navigate("/address")} />
          </div>
          {/* ================= Delivery Toggle ================= */}
          {/* <div className="flex items-center justify-between max-w-md">
            <p className="text-base text-[#191919] font-medium">
              Do you offer home delivery?
            </p>
            <ToggleBtn
              initial={false}
              size={40}
              onChange={(val) => setIsDeliveryEnabled(val)}
            />
          </div> */}
          {/* ================= Delivery Options (Conditional) ================= */}
          {/* {isDeliveryEnabled && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 ">
              
              <div className="border border-[#E5E5E5] rounded-xl p-4 bg-gray-50 space-y-2">
                <p className="text-sm font-medium text-[#191919]">
                  Deliver up to
                </p>
                <div className="flex items-center">
                  <input
                    type="number"
                    placeholder="10"
                    className="flex-1 px-3 py-2 border rounded-l-md outline-none text-sm"
                  />
                  <span className="px-3 py-2 bg-[#FFEFEB] border border-l-0 border-[#FFCCBF] rounded-r-md text-sm">
                    KM
                  </span>
                </div>
              </div>
 
              <div className="border border-[#E5E5E5] rounded-xl p-4 bg-gray-50 space-y-2">
                <p className="text-sm font-medium text-[#191919]">
                  Delivery Price
                </p>
                <div className="flex items-center">
                  <span className="px-3 py-2 bg-[#FFEFEB] border border-r-0 border-[#FFCCBF] rounded-l-md text-sm">
                   {currencySymbol}
                  </span>
                  <input
                    type="number"
                    placeholder="5"
                    className="flex-1 px-3 py-2 border rounded-r-md outline-none text-sm"
                  />
                </div>
              </div>
            </div>
          )} */}
        </div>
      </div>
    </section>
  );
};

export default Addnewaddress;
